import { useDispatch } from '@/store';
import { initialState, setToast } from '@/store/slices/ui';
import * as rtsApi from '@/scene/Meeting/apis/rtsApi';
import styles from './index.module.less';
import {
  Permission,
} from '@/types/state';

interface IProps {
  type: 'start' | 'stop';
  other: {
    message: string;
    userId: string;
  };
}

function Record(props: IProps) {
  const { type, other } = props;

  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(setToast(initialState.toast));
  };

  const handleRecord = async () => {
    if (type === 'start') {
      // 主讲答复观众
      await rtsApi.startRecordPermit({
        permit: Permission.HasPermission,
        apply_user_id: other.userId,
      });
      // 主讲开启云录屏
      await rtsApi.startRecord();
    }

    if (type === 'stop') {
      // 主讲关闭云录屏
      await rtsApi.stopRecord();
    }

    handleClose();
  };

  const handleCancel = async () => {
    // 主讲答复观众
    await rtsApi.startRecordPermit({
      permit: Permission.NoPermission,
      apply_user_id: other.userId,
    });

    handleClose();
  };

  return (
    <div className={styles.wrapper}>
      <span className={styles.message}>{other.message}</span>

      <button className={styles.confirmBtn} onClick={handleRecord}>
        {type === 'start' ? '开始录制' : '结束录制'}
      </button>

      <button className={styles.canceLBtn} onClick={handleCancel}>
        取消
      </button>
    </div>
  );
}

export default Record;
